<div class="email-sent">
  <div class="email-sent__header">
    <img class="email-sent__email-image" [src]="templateOptions.emailImageUrl"/>
    <div class="email-sent__title" translate>
      {{ title }}
    </div>
  </div>
  <div class="email-sent__content">
    <div class="email-sent__message" translate>
      {{ message }}
    </div>
    <button
            mm-button
            color="secondary"
            fluid="true"
            class="email-sent__login-button"
            [routerLink]="returnToLink">
      {{ returnToText | translate }}
    </button>
  </div>
  <div class="email-sent__footer">
    <div translate>PAGES.AUTH.ELEMENTS.DID_NOT_GET_EMAIL_QUESTION</div>
    <div>
      <span translate>PAGES.AUTH.ELEMENTS.CHECK_SPAM</span>
      <a class="email-sent__link" [routerLink]="tryAgainLink" translate>
        REGULAR.TRY_AGAIN
      </a>
    </div>
  </div>
</div>
